{
  "replaceCard": "Replace Card",
  "addCard": "Add a Card",
  "cardInfo": "The added card will be kept on file and may be used for future subscription payments.",
  "nameOnCard": "Name on Card",
  "replacePaymentMethod": "Replace Payment Method",
  "addPaymentMethod": "Add Payment Method",
  "endingIn": "ending in",
  "expires": "Expires",
  "successMessage": "Payment method has been successfully added to your account!",
  "errors": {
    "default": "Unable to update your payment method at the moment, please try again later.",
    "attachFailed": "Unable to attach payment method at the moment. Please try again later.",
    "incompleteForm": "Please complete the payment method form."
  }
}
